export default {
	token: '',
	status: false,
	statusValue: false,
	statusWishlist: false,
	statusWishlistValue: false,
	dateFrom: null,
	dateTo: null
};
